
	import { defineComponent, toRefs } from 'vue'

	export default defineComponent({
		props: {
			packageInfo: {
				type: Object,
				default: () => ({
					money: '',
					timeMinute: ''
				})
			},
			size: {
				type: String,
				default: 'small'
			}
		},
		setup(props) {
			const { money, timeMinute } = toRefs(props.packageInfo)
			return {
				money,
				timeMinute
			}
		}
	})
